import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SupportService} from "@/store/api/supportServiceApi";
interface SupportServiceState {
    supportServiceList: SupportService[];
}

const initialState: SupportServiceState = {
    supportServiceList: [],
}

const supportServiceSlice = createSlice({
    name: 'supportService',
    initialState,
    reducers: {
        setSupportServiceList: (state, action:PayloadAction<SupportService[]>) => {
            state.supportServiceList = action.payload;
        },
        clearSupportServiceList: (state) => {
            state.supportServiceList = [];
        }
    }
})

export const {setSupportServiceList, clearSupportServiceList} = supportServiceSlice.actions;
export default supportServiceSlice.reducer;